import { useState } from 'preact/hooks'
import Icon from 'snippets/icon/icon'
const GreenTick = () => (
  <div className="absolute bottom-0 right-4 top-0 my-auto h-fit w-fit rounded-full bg-secondary-green">
    <Icon id="tick" className="min-h-6 min-w-6 text-primary-white" />
  </div>
)

export const FieldCheckBox = (
  props = {
    name: '',
    value: '',
    required: false,
    onChange: (e) => {},
    children: null,
    checked: false
  }
) => {
  const [isFocused, setIsFocused] = useState(props.checked)

  return (
    <div
      className={`relative min-h-16 w-full overflow-hidden rounded-lg border border-solid border-neutrals-tertiary-grey bg-primary-white transition-colors
        ${isFocused ? 'border-2 border-secondary-green' : 'border-neutrals-tertiary-grey'}`}
    >
      <div
        className={`m-auto flex h-full flex-row items-center justify-between px-4 py-2 transition-opacity  ${
          isFocused ? 'opacity-100' : 'opacity-50'
        }`}
      >
        {props.children}
        {isFocused && <GreenTick />}
      </div>
      <input
        onChange={() => {
          setIsFocused((t) => !t)
        }}
        name={props.name}
        checked={isFocused}
        value={props.value}
        type="checkbox"
        className={'absolute inset-0 z-10 h-full w-full cursor-pointer appearance-none opacity-0 '}
      />
    </div>
  )
}
